// extracted by mini-css-extract-plugin
export default {"page":"Zi-z","cartModal":"_i-z","checkout":"aj-z","placeholder":"bj-z","account":"cj-z"};